export default __webpack_public_path__ + "static/media/xrp.9e752882.svg";